//@flow

export const DEFAULT_DROPDOWN_PLACEHOLDER: string = 'Выберите значение из списка';
export const DEFAULT_DROPDOWN_PLACEHOLDER_TYPEAHEAD: string = 'Начните ввод нужного значения';
export const DEFAULT_DROPDOWN_pathToName: string = 'name';
export const DEFAULT_DROPDOWN_pathToID: string = 'id';
